import { render, staticRenderFns } from "./approval-button.vue?vue&type=template&id=002f4f0e&scoped=true"
import script from "./approval-button.vue?vue&type=script&lang=js"
export * from "./approval-button.vue?vue&type=script&lang=js"
import style0 from "./approval-button.vue?vue&type=style&index=0&id=002f4f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f4f0e",
  null
  
)

export default component.exports